import { useQuery } from '@tanstack/react-query';
import type { Project } from '../types';

const API_URL = '/api';

export function useProjects() {
  const { data: projects = [], isLoading } = useQuery<Project[]>({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await fetch(`${API_URL}/projects`);
      if (!response.ok) throw new Error('Failed to fetch projects');
      return response.json();
    },
  });

  return { projects, isLoading };
}

